'use strict';

import _ from 'lodash';
import React from 'react';
import Analytics from '../common/analytics';

class Safety_Protocols extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let html = this.props.conference.current.safety_html ?
      this.props.conference.current.safety_html : null;

    return <div className="safety-protocols">
      <section className="section">
        <div className="html wrap-two clearfix">
          <div className="title">Safety Protocols</div>
          <div className="summary" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </section>
      <Analytics view="safety_protocols" {...this.props} />
    </div>
  }
}

export default Safety_Protocols;
